import { EmailDistributionApi } from 'api/EmailDistributionApi';
import { backendApiClient } from 'container/backendApiClient';

export const emailDistributionApi = new EmailDistributionApi(backendApiClient);
